import { render, staticRenderFns } from "./childTable.vue?vue&type=template&id=b62acf4e&scoped=true"
import script from "./childTable.vue?vue&type=script&lang=js"
export * from "./childTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62acf4e",
  null
  
)

export default component.exports